import axios from '@/axios.js'
import { QuerySerialize } from '@/utils'
import { notifyServerError } from '@/layouts/notifies'

export default {
  createReserve(context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('reserves/', data)
        .then(response => {
          // commit('ADD_ITEM', Object.assign(data, { id: response.data.id }))
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  countReserves(context) {
    const query = QuerySerialize(context.state.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`reserves/count/?${query}`)
        .then(response => {
          context.commit('SET_ITEMS_COUNT', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchReserves(context) {
    const query = QuerySerialize(context.state.query)
    const skip = context.state.skip
    const limit = context.state.limit
    return new Promise((resolve, reject) => {
      axios
        .get(`reserves/?skip=${skip}&limit=${limit}&${query}`)
        .then(response => {
          context.commit('SET_ITEMS', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchReserve(context, itemId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`reserves/${itemId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  removeReserve(context, itemId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`reserves/${itemId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editReserve(context, item) {
    return new Promise((resolve, reject) => {
      axios
        .put(`reserves/${item.id}`, item.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  testReserve(context, item) {
    return new Promise((resolve, reject) => {
      axios
        .post(`reserves/test`, item)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
